var render, staticRenderFns
import script from "./TransitionExpand.vue?vue&type=script&lang=js"
export * from "./TransitionExpand.vue?vue&type=script&lang=js"
import style0 from "./TransitionExpand.vue?vue&type=style&index=0&id=43fe50c3&prod&scoped=true&lang=css"
import style1 from "./TransitionExpand.vue?vue&type=style&index=1&id=43fe50c3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43fe50c3",
  null
  
)

export default component.exports